// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { registerComponent, ObjectSwitcher as JswObjectSwitcher } from 'jsw';
import JswComponent from '../../jsw/JswComponent';
import useNavigate from 'hooks/useNavigate';

const ObjectSwitcher = ({ locale, limit, lookUpParams, dataUrl, listUrl, owner = null, itemUrlTemplate }) => {
    const [component, setComponent] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const newComponent = new JswObjectSwitcher({ locale, limit, lookUpParams, dataUrl, listUrl, owner, itemUrlTemplate, navigate });
        setComponent(newComponent);

        return () => {
            registerComponent(newComponent.getId());
            setComponent(null);
        };
    }, [locale, limit, lookUpParams, dataUrl, listUrl, owner, itemUrlTemplate, navigate]);

    return component ? (
        <JswComponent component="span" key={component.getId()}>
            {component}
        </JswComponent>
    ) : null;
};

ObjectSwitcher.propTypes = {
    locale: PropTypes.object.isRequired,
    limit: PropTypes.number.isRequired,
    lookUpParams: PropTypes.object.isRequired,
    dataUrl: PropTypes.string.isRequired,
    listUrl: PropTypes.string.isRequired,
    owner: PropTypes.string,
    itemUrlTemplate: PropTypes.string.isRequired,
};

export default ObjectSwitcher;
